import React from 'react';

const formatTemplate = (template, values = {}) => (
    String(template || '').replace(/\{(\w+)\}/g, (match, key) => (
        values[key] !== undefined ? values[key] : match
    ))
);

const formatNumber = (value, locale) => {
    const numberValue = Number(value);
    return Number.isFinite(numberValue) ? numberValue.toLocaleString(locale || undefined) : '--';
};

export const getCompanyInitials = (name) => {
    const words = String(name || '')
        .trim()
        .split(/\s+/)
        .filter(Boolean);
    if (words.length === 0) return 'C';
    return words
        .slice(0, 2)
        .map((word) => word[0])
        .join('')
        .toUpperCase();
};

const CustomerProfileLogo = ({ customer, copy }) => {
    const displayName = customer?.displayName || customer?.name || copy.title;
    if (customer?.logoUrl) {
        return (
            <img
                className="customer-profile-logo"
                src={customer.logoUrl}
                alt={customer.logoAltText || `${displayName} logo`}
            />
        );
    }

    return (
        <div
            className="customer-profile-logo-placeholder"
            role="img"
            aria-label={formatTemplate(copy.profile.logoFallbackLabel, { company: displayName })}
        >
            {getCompanyInitials(displayName)}
        </div>
    );
};

export default function CustomerProfileHeader({ copy, locale, profileState }) {
    const profile = profileState.profile;
    const customer = profile?.customer || {};
    const stats = profile?.fleetStats || {};
    const displayName = customer.displayName || customer.name || copy.title;
    const metrics = [
        {
            label: copy.profile.metrics.totalVehicles,
            value: stats.totalVehicles,
        },
        {
            label: copy.profile.metrics.operationalVehicles,
            value: stats.operationalVehicles,
        },
    ];
    const statusMessage = profileState.status === 'loading'
        ? copy.profile.loading
        : profileState.status === 'error'
            ? copy.profile.unavailable
            : '';

    return (
        <header className="customer-profile-header" aria-busy={profileState.status === 'loading'}>
            <div className="customer-profile-identity">
                <CustomerProfileLogo customer={customer} copy={copy} />
                <div className="customer-profile-title-group">
                    <span className="customer-profile-context">{copy.profile.subtitle}</span>
                    <h1>{displayName}</h1>
                    {customer.identifier && (
                        <span className="customer-profile-identifier">{customer.identifier}</span>
                    )}
                    {statusMessage && (
                        <span className={`customer-profile-status ${profileState.status}`} role="status">
                            {statusMessage}
                        </span>
                    )}
                </div>
            </div>

            <dl className="customer-profile-metrics" aria-label={copy.profile.subtitle}>
                {metrics.map((metric) => {
                    const hasMetricValue = profileState.status === 'ready'
                        && metric.value !== null
                        && metric.value !== undefined;
                    return (
                        <div className="customer-profile-metric" key={metric.label}>
                            <dt>{metric.label}</dt>
                            <dd className={hasMetricValue ? '' : 'customer-profile-metric-unavailable'}>
                                {hasMetricValue ? formatNumber(metric.value, locale) : '--'}
                            </dd>
                        </div>
                    );
                })}
            </dl>
        </header>
    );
}
